import { render, staticRenderFns } from "./AppraisalCard.vue?vue&type=template&id=bb6f68f4&scoped=true&"
import script from "./AppraisalCard.vue?vue&type=script&lang=ts&"
export * from "./AppraisalCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6f68f4",
  null
  
)

export default component.exports